module.exports = __webpack_public_path__ + "img/circle-mobile.9dd7ed96.svg";